/**
 * <s-countdown> — ticking countdown to a fixed instant.
 *
 * Attributes:
 *   target — ISO 8601 date-time the countdown reaches zero at.
 * Children:
 *   [data-unit="days|hours|minutes|seconds"] — receive zero-padded values.
 *   [data-countdown-running] — hidden once the target passes.
 *   [data-countdown-done] — shown once the target passes.
 */
class SCountdown extends HTMLElement {
  #timer = null;
  #target = 0;

  connectedCallback() {
    this.#target = Date.parse(this.getAttribute('target') || '');
    if (Number.isNaN(this.#target)) return;
    this.#tick();
    this.#timer = setInterval(() => this.#tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.#timer);
  }

  #tick() {
    const remaining = Math.max(0, this.#target - Date.now());
    const totalSeconds = Math.floor(remaining / 1000);
    const values = {
      days: Math.floor(totalSeconds / 86400),
      hours: Math.floor((totalSeconds % 86400) / 3600),
      minutes: Math.floor((totalSeconds % 3600) / 60),
      seconds: totalSeconds % 60,
    };

    for (const [unit, value] of Object.entries(values)) {
      const el = this.querySelector(`[data-unit="${unit}"]`);
      if (el) el.textContent = String(value).padStart(2, '0');
    }

    if (remaining === 0) {
      clearInterval(this.#timer);
      this.querySelectorAll('[data-countdown-running]').forEach((el) => { el.hidden = true; });
      this.querySelectorAll('[data-countdown-done]').forEach((el) => { el.hidden = false; });
    }
  }
}

customElements.define('s-countdown', SCountdown);
